var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event__list_select_update_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'name',
                title: 'Name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'numberOfSessions',
                title: 'Sessions',
                type: 'number',
                sortable: false,
                queryable: false
            },
            {
                key: 'nextSessionDate',
                title: 'Next session',
                type: 'date',
                sortable: false,
                queryable: false
            },
            {
                key: 'courses',
                title: 'Courses',
                type: 'date',
                sortable: false,
                queryable: false
            },
            {
                key: 'status',
                title: 'Status',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'actions',
                title: '',
                type: '',
                sortable: false
            }
        ],"items":_vm.items,"component-table-item":_vm.EventListSelectUpdateTableItem},on:{"emit-selected":_vm.selectItem}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"event__list_select_update_table_actions"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"}),_c('div',{staticClass:"column is-narrow"},[_c('component-button',{attrs:{"theme":'default',"border":true,"to":{ name: 'ebs-event-list' },"name":'event-list-select-update-table-actions-cancel'}},[_vm._v(_vm._s(_vm.$t('ebs.events.list.buttons.buttonCancel'))+"\n                    ")])],1),(_vm.selected)?[_c('div',{staticClass:"column is-narrow"},[_c('component-button',{attrs:{"animate-loading":true,"name":'event-list-select-update-table-actions-select'},on:{"click":_vm.updateSelectedEvent}},[_vm._v(_vm._s(_vm.$t('ebs.events.list.buttons.addSelectEvent'))+"\n                        ")])],1)]:_vm._e()],2)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }